import React, { Component } from 'react';
import { Modal, Checkbox, Button, Icon, Spin } from 'antd';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import './style.less';

// 模块级共享：同屏多个筛选实例首开只发一次BA人员请求；失败后清空，下次打开重试
let baTreeData = null;
let baTreeFetching = null;
const fetchBaTreeData = () => {
    if (!baTreeFetching) {
        baTreeFetching = Fetch.post(API_URL.requestDataAnalysis.queryUnregisteredContractBA)
            .then(res => {
                baTreeData = res;
                return baTreeData;
            })
            .catch(err => {
                console.error(err);
                baTreeFetching = null;
                return null;
            });
    }
    return baTreeFetching;
};

class SelectBa extends Component {
    constructor(props) {
        super(props);
        const { checkedKeys = [], expandedKeys = [], lastLeaf = [] } = props;
        this.state = {
            visible: false,
            data: [],
            loading: false,
            checkedKeys,
            expandedKeys,
            lastLeaf
        };
    }

    dictLoaded = false

    show = () => {
        // BA人员数据与项目数据无关，首开一次；请求失败则下次打开自动重试
        if (!this.dictLoaded) {
            this.setState({ loading: true });
            this.loadData();
        }
        this.setState({ visible: true });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        fetchBaTreeData().then(res => {
            if (!res) {
                this.setState({ loading: false });
                return;
            }
            const { datas: { baPersonGroups } = {} } = res;
            this.dictLoaded = true;
            this.setState({ data: this.adaptData(baPersonGroups), loading: false });
        });
    }

    // 构建树
    adaptData = (data) => {
        const key = '0';

        const result = (data || []).map((item, index) => {
            const { baLeaderName, baPeople } = item;
            const subKey = `${key}-${index}`;

            const children = (baPeople || []).map((innerItem, innerIndex) => {
                const { userCompellation, employeeCode, userDetailId } = innerItem;
                return { key: `${subKey}-${innerIndex}`, title: `${userCompellation}[${employeeCode}]`, id: userDetailId };
            });

            return { key: subKey, title: `${baLeaderName}组`, children };
        });
        return [{
            key,
            title: '所有BA',
            children: result,
        }];
    }

    acquireDataByStatus = (key, data) => {
        let list = [...data];
        if (list.includes(key)) {
            list = list.filter(i => i !== key);
        } else {
            list.push(key);
        }
        return list;
    }

    handleExpand = (key) => {
        this.setState({ expandedKeys: this.acquireDataByStatus(key, this.state.expandedKeys) });
    }

    // 获取节点
    acquireNodeData = (list, pos) => {
        const tiers = pos.split('-');
        const tier = tiers.shift();
        const nextPos = tiers.join('-');
        if (!nextPos) {
            return list[tier];
        } else {
            return this.acquireNodeData(list[tier].children, nextPos);
        }
    }

    // 获取上层
    acquireUpperTier = (pos) => {
        const tiers = pos.split('-');
        tiers.pop();
        return tiers.join('-');
    }

    // 根据当前节点下层节点的状态更改当前节点的状态
    traverseUpperTier = (checkedKeys, pos) => {
        if (!pos) return;
        const { key, children } = this.acquireNodeData(this.state.data, pos);
        const allSelected = (children || []).every(i => checkedKeys.includes(i.key));
        const index = checkedKeys.indexOf(key);
        if (allSelected && (index === -1)) {
            checkedKeys.push(key);
        } else if (!allSelected && (index !== -1)) {
            checkedKeys.splice(index, 1);
        }
        this.traverseUpperTier(checkedKeys, this.acquireUpperTier(pos));
    }

    // 根据节点状态更改其下层节点的状态
    traverseDownTier = (checkedKeys, data, checked, lastLeaf) => {
        if (!(data || []).length) return;

        (data || []).forEach(i => {
            const { key, children } = i;
            const index = checkedKeys.indexOf(key);
            if (checked && (index === -1)) {
                checkedKeys.push(key);
            } else if (!checked && (index !== -1)) {
                checkedKeys.splice(index, 1);
            }
            this.setLastLeaf(checked, i, lastLeaf);  
            this.traverseDownTier(checkedKeys, children, checked, lastLeaf);
        });
    }

    /**
     * 1. 选择/取消选择，下层节点同步
     * 2. 当前节点如果都选择，那么上层节点也选择
     */
    handleCheck = (e) => {
        let { data, checkedKeys, lastLeaf } = this.state;
        const { value, checked } = e.target;
        
        checkedKeys = this.acquireDataByStatus(value, checkedKeys);
        const nodeData = this.acquireNodeData(data, value);
        this.setLastLeaf(checked, nodeData, lastLeaf);
        this.traverseDownTier(checkedKeys, nodeData.children, checked, lastLeaf);
        this.traverseUpperTier(checkedKeys, this.acquireUpperTier(value));
        this.setState({
            lastLeaf,
            checkedKeys,
        });
    }

    setLastLeaf = (checked, data, lastLeaf) => {
        const { id, title, children } = data;
        if (children) return;
        const index = lastLeaf.findIndex(i => i.id == id);
        if (checked && (index === -1)) {
            lastLeaf.push({ id, title });
        } else if (!checked && (index !== -1)) {
            lastLeaf.splice(index, 1);
        }
    }

    /**
     *  按树型结构渲染数据
     *  1. 遍历当前层级，渲染层级节点
     *  2. 是否含有子节点，存在则渲染
     */
    getContent = (data, tier) => {
        if (!(data || []).length) return null;

        const { checkedKeys, expandedKeys } = this.state;
        return (
            <ul className={`tree tree-${tier}`}>
                {
                    (data || []).map((item, index) => {
                        const { key, title, children } = item;
                        const last = !children;
                        const expanded = expandedKeys.includes(key);
                        const checked = checkedKeys.includes(key);
                        return (
                            <li key={key} className={`leaf${last ? ' last' : ''}`}>
                                <div className="leaf-content">
                                    {
                                        !last &&
                                        <Icon
                                            type={ expanded ? "caret-down"  : "caret-right" }
                                            onClick={() => this.handleExpand(key)}
                                        />
                                    }
                                    <Checkbox
                                        onChange={this.handleCheck}
                                        checked={checked}
                                        value={key}
                                    >{title}</Checkbox>
                                </div>
                                { expanded && this.getContent(children, tier + 1) }
                            </li>
                        );
                    })
                }
            </ul>
        );
    }

    confirm = () => {
        const { lastLeaf, checkedKeys, expandedKeys } = this.state;
        this.props.onChange({ lastLeaf, checkedKeys, expandedKeys });
        this.hide();
    }
    
    render() {
        const { visible, data, loading } = this.state
        return (
            <Modal
                title="选择BA"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                className="create-modal"
                footer={<Button type="ghost" onClick={this.confirm}>确定</Button>}
                width="400px"
            >
                <Spin spinning={loading}>
                    {this.getContent(data, 0)}
                </Spin>
            </Modal>
        );
    }
}

export default SelectBa;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/components/SelectBa/index.js